import React from "react";

import { AvgQuestionAsked } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/AvgQuestionAsked/AvgQuestionAsked";
import { AvgVideoUploadTime } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/AvgVideoUploadTime/AvgVideoUploadTime";
import { CommentDistribution } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/CommentDistribution/CommentDistribution";
import { RBTResponseToBCBAQuestionRawData } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/RBTResponseToBCBAQuestion/RBTResponseToBCBAQuestionRawData";
import { VideoRecordingDuration } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/VideoRecordingDuration/VideoRecordingDuration";
import { VideosRecorded } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/VideosRecorded/VideosRecorded";
import { GraphRawDataDialog } from "@pages/VideoAnalytics/components/GraphRawDataDialog";
import { RBT_ANALYTICS_TITLES } from "@pages/VideoAnalytics/helpers";

interface GraphDialogsProps {
  isVideosRecordedDialogOpen: boolean;
  setIsVideosRecordedDialogOpen: (open: boolean) => void;
  isVideoRecordingDurationDialogOpen: boolean;
  setIsVideoRecordingDurationDialogOpen: (open: boolean) => void;
  isAvgVideoUploadTimeDialogOpen: boolean;
  setIsAvgVideoUploadTimeDialogOpen: (open: boolean) => void;
  isRBTResToBCBAQueDialogOpen: boolean;
  setIsRBTResToBCBAQueDialogOpen: (open: boolean) => void;
  isRBTResRateToBCBAQuesDialogOpen: boolean;
  setIsRBTResRateToBCBAQuesDialogOpen: (open: boolean) => void;
  isCommentOpen: boolean;
  setIsCommentOpen: (open: boolean) => void;
  isCommentDistributionOpen: boolean;
  setIsCommentDistributionOpen: (open: boolean) => void;
  isAvgQuestionAsked: boolean;
  setIsAvgQuestionAsked: (open: boolean) => void;
}

export const GraphDialogs: React.FC<GraphDialogsProps> = ({
  isVideosRecordedDialogOpen,
  setIsVideosRecordedDialogOpen,
  isVideoRecordingDurationDialogOpen,
  setIsVideoRecordingDurationDialogOpen,
  isAvgVideoUploadTimeDialogOpen,
  setIsAvgVideoUploadTimeDialogOpen,
  isRBTResToBCBAQueDialogOpen,
  setIsRBTResToBCBAQueDialogOpen,
  isRBTResRateToBCBAQuesDialogOpen,
  setIsRBTResRateToBCBAQuesDialogOpen,
  isCommentDistributionOpen,
  setIsCommentDistributionOpen,
  isCommentOpen,
  setIsCommentOpen,
  isAvgQuestionAsked,
  setIsAvgQuestionAsked,
}) => {
  return (
    <div>
      <GraphRawDataDialog
        title={RBT_ANALYTICS_TITLES.TOTAL_VIDEOS_RECORDED}
        open={isVideosRecordedDialogOpen}
        setOpen={setIsVideosRecordedDialogOpen}
      >
        <VideosRecorded />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={RBT_ANALYTICS_TITLES.VIDEO_RECORDING_DURATION}
        open={isVideoRecordingDurationDialogOpen}
        setOpen={setIsVideoRecordingDurationDialogOpen}
      >
        <VideoRecordingDuration />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={RBT_ANALYTICS_TITLES.AVG_VIDEO_UPLOAD_TIME}
        open={isAvgVideoUploadTimeDialogOpen}
        setOpen={setIsAvgVideoUploadTimeDialogOpen}
      >
        <AvgVideoUploadTime />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={RBT_ANALYTICS_TITLES.AVG_RESPONSE_TIME_TO_BCBA_QUESTIONS}
        open={isRBTResToBCBAQueDialogOpen}
        setOpen={setIsRBTResToBCBAQueDialogOpen}
      >
        <RBTResponseToBCBAQuestionRawData forResponseRate={false} />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={RBT_ANALYTICS_TITLES.AVG_RESPONSE_RATE_TO_BCBA_QUESTIONS}
        open={isRBTResRateToBCBAQuesDialogOpen}
        setOpen={setIsRBTResRateToBCBAQuesDialogOpen}
      >
        <RBTResponseToBCBAQuestionRawData forResponseRate={true} />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={RBT_ANALYTICS_TITLES.AVG_COMMENT_RECEIVED_PER_VIDEO}
        open={isCommentOpen}
        setOpen={setIsCommentOpen}
      >
        <CommentDistribution isCommentDistributionWithCommentType={false} />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={RBT_ANALYTICS_TITLES.TOTAL_COMMENTS_RECEIVED}
        open={isCommentDistributionOpen}
        setOpen={setIsCommentDistributionOpen}
      >
        <CommentDistribution isCommentDistributionWithCommentType={true} />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={RBT_ANALYTICS_TITLES.AVG_QUESTIONS_ASKED_PER_VIDEO}
        open={isAvgQuestionAsked}
        setOpen={setIsAvgQuestionAsked}
      >
        <AvgQuestionAsked />
      </GraphRawDataDialog>
    </div>
  );
};
